import React from 'react';
import { styled } from '@linaria/react';
import { useInView } from '@daedalus/core/src/_web/utils/browser/hooks/useInView';
interface Props {
  months: string[];
  isCheckInMonth: boolean;
  checkInMonthRef?: React.MutableRefObject<HTMLDivElement | null>;
  date: Date;
  onInView?: (date: Date) => void;
}
const CaptionElement = /*#__PURE__*/styled('div')({
  name: "CaptionElement",
  class: "c211rcs",
  propsAsIs: false
});
export const MonthName = ({
  months,
  isCheckInMonth,
  checkInMonthRef,
  date,
  onInView
}: Props) => {
  const {
    ref: monthRef,
    inView: isMonthInView
  } = useInView();
  if (isMonthInView) {
    onInView?.(date);
  }
  return <CaptionElement {...isCheckInMonth ? {
    ref: checkInMonthRef
  } : {
    ref: monthRef
  }}>
      {months && `${months[date.getMonth()]} ${date.getFullYear()}`}
    </CaptionElement>;
};

require("./MonthName.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MonthName.tsx");